// extracted by mini-css-extract-plugin
module.exports =  {"root":"ElmMUxDgKxpemb0W6sFP","left":"c60wzcd9Pl2W08r0AhGg","right":"xxuxpeXCLFEnIyWRyvQ_","alert":"KVP9SVo7IjPjdoxh4Ip0","estimatedReach":"x_GfpVo4ffVwpJusD9mt"};